"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import styles from '../ProgressBar.module.scss.mjs';
import 'react';
import { useNumberFormatter, useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../../_virtual/_.locale.json@162914df08c90e5e10d2f78b03d9d768.mjs';

const ProgressBarValue = (props) => {
  const {
    showMaxValue,
    maxValue,
    value = 0,
    formatOptions,
    valueLabel
  } = props;
  const formatter = useNumberFormatter(formatOptions);
  const stringFormatter = useLocalizedStringFormatter(locales);
  const maxValueText = !showMaxValue || !maxValue ? void 0 : formatOptions ? formatter.format(maxValue) : `${maxValue} %`;
  const valueText = formatOptions ? formatter.format(value) : `${value} %`;
  const textWithMaxValue = `${value} ${stringFormatter.format("progressBar.of")} ${maxValueText}`;
  return /* @__PURE__ */ jsx("span", { className: styles.value, children: valueLabel ?? (maxValueText ? textWithMaxValue : valueText) });
};

export { ProgressBarValue };
//# sourceMappingURL=ProgressBarValue.mjs.map
